export default {
  props: {
    disclaimer: {
      type: String,
      default: '',
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/wallet/shared/deposit-disclaimer/deposit-disclaimer.js